"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const tokens = __importStar(require("@trp-rps-rps-shared-web/rps-shared-web-styles"));
const StyledInput = styled_components_1.default.input `
  height: 0;
  width: 0;
  visibility: hidden;
`;
const StyledLabel = styled_components_1.default.label `
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  width: 40px;
  height: 24px;
  background: ${tokens.ColorWhite200};
  border-radius: 100px;
  position: relative;
  transition: background-color 0.2s;
  ${(props) => props.isOn &&
    styled_components_1.css `
      background: ${tokens.ColorBrandInteractiveBlue};
    `}
`;
const StyledToggle = styled_components_1.default.span `
  content: "";
  position: absolute;
  top: 4px;
  left: 4px;
  width: 16px;
  height: 16px;

  border-radius: 50%;
  transition: 0.5s;
  background: #fff;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.25);
  ${(props) => props.isOn &&
    styled_components_1.css `
      left: calc(100% - 4px);
      transform: translateX(-100%);
    `}
`;
const StyledToggleState = styled_components_1.default.span `
  margin-left: 56px;
  font-family: Nimbus Sans Regular;
`;
class Toggle extends react_1.Component {
    render() {
        const { isOn, handleToggle, id, showToggleState } = this.props;
        return (react_1.default.createElement("div", null,
            react_1.default.createElement(StyledInput, { checked: isOn, onChange: handleToggle, id: id, type: "checkbox" }),
            react_1.default.createElement(StyledLabel, { className: "react-switch-label", htmlFor: id, isOn: isOn },
                react_1.default.createElement(StyledToggle, { isOn: isOn }),
                " ",
                react_1.default.createElement(StyledToggleState, null, showToggleState ? (isOn ? "Yes" : "No") : ""))));
    }
}
exports.default = Toggle;
//# sourceMappingURL=Toggle.js.map